import { DatePipe, NgFor, NgIf } from "@angular/common";
import { Component, HostListener, Inject, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogActions,
} from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { Config } from "datatables.net";
import { IncidenciasService } from "src/app/incidencias/incidencias.service";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { SweetAlertComponent } from "src/app/shared/SweetMesssage";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import { EvidenciaBean } from "src/app/shared/model/incidencias/evidenciaBean.model";
import { Proyectos } from "src/app/shared/model/incidencias/proyectos.model";
import { TareaDiaria } from "src/app/shared/model/tarea/tareaDiaria.model";
import { Estatus } from "src/app/shared/model/tickets/estatus.model";
import { EvidenciaViewerService } from "src/app/shared/services/evidencia-viewer.service";
import { GenericoService } from "src/app/shared/services/generico.service";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { EstatusTareaEnum } from "src/app/utilerias/enums/estatusTareaDiariaEnum";
import { MensajesFijosEnum } from "src/app/utilerias/enums/mensajes-fijos-enum";
import { UtileriasService } from "src/app/utilerias/service/utilerias.service";
import swal from "sweetalert2";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import {
  MatFormField,
  MatInput,
  MatLabel,
  MatSuffix,
  MatError,
} from "@angular/material/input";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/autocomplete";
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from "@angular/material/datepicker";
import { SoloNumeroPuntosDirective } from "../../../utilerias/directives/solo-numero-puntos.directive";
import {
  MatSelectionList,
  MatListOption,
} from "@angular/material/list";
import { firstValueFrom } from "rxjs";
const horaInicioCtrl = "horaInicioCtrl";
const horaFinCtrl = "horaFinCtrl";
const fechaInicioCtrl = "fechaInicioCtrl";
const fechaFinalCtrl = "fechaFinalCtrl";
const horasInvertidasCtrl = "horasInvertidasCtrl";
/**
 * Tipo de consulta de PoyectosBussines: proyectos donde un colaborador
 * (param4) está o estuvo, para que su líder le registre una tarea anterior.
 * Es el criterio con historial (criterioIntegranteConHistorial), no el de
 * «Registrar tarea» (tipo 7): cuenta integrantesLiberados y no exige ACTIVO.
 */
const CONSULTA_PROYECTOS_COLABORADOR = 8;

@Component({
  selector: "app-modal-tarea-anterior",
  templateUrl: "./modal-tarea-anterior.component.html",
  styleUrls: ["./modal-tarea-anterior.component.css"],
  imports: [
    MatIconButton,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatSelect,
    NgFor,
    MatOption,
    MatInput,
    MatLabel,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatError,
    NgIf,
    SoloNumeroPuntosDirective,
    MatSelectionList,
    MatListOption,
    MatDialogActions,
    MatButton,
  ],
})
export class ModalTareaAnteriorComponent implements OnInit {
  @ViewChild("proyectoSelect") proyectoSelect?: MatSelect;
  @ViewChild("estatusSelect") estatusSelect?: MatSelect;

  proyectos: Array<Proyecto>;
  titulo: string;
  tareaAltaFormGroup: FormGroup;
  tarea: TareaDiaria;
  horaInicio;
  fechaInicio;
  fechaFin;
  horaFin;
  idUsuario;
  esAlta: boolean;
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  totalsize = Constantes.CERO;
  evidencia = [];
  selectedOptions = [];
  index: number;
  evidenciaBean: EvidenciaBean = new EvidenciaBean();
  minDate = new Date();
  maxDate = new Date();
  requestFilter = new ConsultaList<Proyecto>();
  nomProyecto: string = "";
  clientefl: number = null;
  tblHuCuPaginacion: Config = {};
  listaEstatus: any[];

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private utilerias: UtileriasService,
    private datePipe: DatePipe,
    private incidenciaService: IncidenciasService,
    private service: GenericoService,
    private sweetAlert: SweetAlertComponent,
    private sanitizer: DomSanitizer,
    private proyectoService: ProyectosService,
    private dialog: MatDialog,
    private visorEvidencias: EvidenciaViewerService,
    private incidenciasService: IncidenciasService
  ) {}

  ngOnInit() {
    this.idUsuario = this.data.idUsuario;
    this.maxDate.setDate(this.maxDate.getDate() - 1);
    this.minDate.setMonth(this.minDate.getMonth() - 828);

    this.inicializarValores();
    this.obtenerProyectos();
    this.inicializarForm();
    this.obtenerEstatus();
  }

  @HostListener("document:click", ["$event"])
  cerrarSelectsAlHacerClickFuera(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;

    if (
      target?.closest(".mat-mdc-select-trigger") ||
      target?.closest(".modal-tarea-anterior-select-panel")
    ) {
      return;
    }

    this.proyectoSelect?.close();
    this.estatusSelect?.close();
  }

  cerrarSelectAlterno(abierto: boolean, selectActivo: "proyecto" | "estatus"): void {
    if (!abierto) {
      return;
    }

    if (selectActivo === "proyecto") {
      this.estatusSelect?.close();
      return;
    }

    this.proyectoSelect?.close();
  }

  inicializarValores() {
    if (this.data.tarea !== null) {
      this.titulo = "MODIFICAR TAREA";
      this.esAlta = false;
      this.tarea = this.data.tarea;
      this.fechaInicio = this.tarea.fecha_inicio;
      this.fechaFin = this.tarea.fecha_fin;
      this.horaInicio = this.datePipe.transform(
        this.fechaInicio,
        Constantes.FORMATO_HORA_MINUTOS
      );
      this.horaFin = this.datePipe.transform(
        this.fechaFin,
        Constantes.FORMATO_HORA_MINUTOS
      );
    } else {
      this.titulo = "ALTA TAREA";
      this.esAlta = true;
      this.tarea = new TareaDiaria();
      this.fechaInicio = this.data.fechaTarea;

      this.horaInicio = this.datePipe.transform(
        new Date(),
        Constantes.FORMATO_HORA_MINUTOS
      );
      this.horaFin = this.datePipe.transform(
        new Date(),
        Constantes.FORMATO_HORA_MINUTOS
      );
    }
  }

  inicializarForm() {
    this.tareaAltaFormGroup = this.formBuilder.group({
      nombreCtrl: new FormControl("", Validators.required),
      descripcionCtrl: new FormControl("", Validators.required),
      proyectoCtrl: new FormControl("", Validators.required),
      fechaInicioCtrl: new FormControl("", Validators.required),
      fechaFinalCtrl: new FormControl("", Validators.required),
      horasInvertidasCtrl: new FormControl("", Validators.required),
      horaInicioCtrl: new FormControl("", Validators.required),
      horaFinCtrl: new FormControl("", Validators.required),
      estatusCtrl: new FormControl("", Validators.required),
    });
    this.tareaAltaFormGroup
      .get(fechaInicioCtrl)
      .valueChanges.subscribe((valor) => {
        if (valor) {
          this.tareaAltaFormGroup.get(horasInvertidasCtrl).enable();
        } else {
          this.tareaAltaFormGroup.get(horasInvertidasCtrl).disable();
        }
      });
    this.tareaAltaFormGroup.get(fechaFinalCtrl).disable();
    this.tareaAltaFormGroup.get(horaFinCtrl).disable();
  }

  obtenerEstatus() {
    const estatus = Object.keys(EstatusTareaEnum).map((estatus) => ({
      estatus,
      value: EstatusTareaEnum[estatus],
    }));
    this.listaEstatus = estatus.filter(
      (estatus) => estatus.value !== "PENDIENTE"
    );
  }

  onChangFecha($event: any, arg1: boolean) {
    this.fechaFin = $event;
    this.tareaAltaFormGroup.get(fechaInicioCtrl).disable();
  }

  sumarHoras($event: any, cambio: boolean) {
    const horasSuma = new Date(this.fechaInicio);
    const horaInicio = this.horaInicio.split(Constantes.DOS_PUNTOS)[
      Constantes.CERO
    ];
    horasSuma.setHours(horaInicio);
    const minutoInicio = this.horaInicio.split(Constantes.DOS_PUNTOS)[
      Constantes.UNO
    ];
    horasSuma.setMinutes(minutoInicio);

    if (this.tareaAltaFormGroup.get(horasInvertidasCtrl).value != null) {
      const [hora, min, seg] = $event.split(Constantes.DOS_PUNTOS);

      horasSuma.setHours(horasSuma.getHours() + Number(hora));
      horasSuma.setMinutes(horasSuma.getMinutes() + Number(min));
      this.horaFin = this.datePipe.transform(
        horasSuma.getTime(),
        Constantes.FORMATO_HORA_MINUTOS
      );
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  /**
   * Proyectos del colaborador (param4), no los del líder que captura: con él
   * en el equipo, como líder o ya liberado (cierre, quitado o baja), en
   * cualquier estatus (también cerrados o en pausa), sin oportunidades. Es
   * trabajo ya hecho. El backend revisa que el colaborador sea del tenant.
   * Antes era el tipo 2 con 10 registros, así que faltaban proyectos.
   */
  obtenerProyectos() {
    this.requestFilter.param1 = this.nomProyecto;
    this.requestFilter.param4 = this.idUsuario;
    this.requestFilter.param6 = CONSULTA_PROYECTOS_COLABORADOR;
    this.requestFilter.pagina = Constantes.CERO;
    this.requestFilter.regXPagina = Constantes.MIL;

    this.proyectoService.consultaProyectoMongo(this.requestFilter).subscribe({
      next: (response: { content?: Proyecto[] } | null) => {
        this.proyectos = this.conProyectoDeLaTarea(response?.content ?? []);
      },
      error: () => {
        this.proyectos = this.conProyectoDeLaTarea([]);
      },
    });
  }

  /**
   * Al modificar, el proyecto de la tarea puede no venir en la lista (por
   * ejemplo, ya no existe, es oportunidad o, en datos viejos, el colaborador
   * no aparece ni entre los liberados). Se agrega para que el campo lo siga
   * mostrando y la tarea conserve su proyecto.
   */
  private conProyectoDeLaTarea(proyectos: Proyecto[]): Proyecto[] {
    const idProyecto = this.esAlta ? null : this.tarea?.idProyecto;
    if (!idProyecto || proyectos.some((p) => String(p?.id) === String(idProyecto))) {
      return proyectos;
    }
    const actual = new Proyecto();
    actual.id = String(idProyecto);
    actual.nombre = this.data?.nombreProyecto || "Proyecto actual de la tarea";
    return [actual, ...proyectos];
  }

  public guardar() {
    this.convertirFechasHoras();
    this.tarea.idUsuario = this.idUsuario;

    firstValueFrom(
      this.incidenciaService.obtenerElementoPorCampoPost(
        UrlConstantes.REGISTRAR_ACTUALIZAR_TAREA_COLABORADOR,
        this.tarea
      )
    )
      .then((tareaRes: TareaDiaria | null) => {
        if (tareaRes && this.utilerias.validarcodigoError(tareaRes.pCodRetorno)) {
          if (this.evidencia.length > Constantes.CERO) {
            const formData = new FormData();
            for (let i = 0; i < this.evidencia.length; i++) {
              formData.append(
                "file",
                this.evidencia[i],
                "TAREA" +
                  "$" +
                  "QA" +
                  "$" +
                  tareaRes.id +
                  "$" +
                  tareaRes.idProyecto +
                  "$" +
                  this.evidencia[i].name
              );
            }
            this.incidenciasService.uploadEvidenciaTarea(formData).subscribe();
          }
          this.sweetAlert.showSwal("success-message", tareaRes.pMensaje);
          this.dialogRef.close(true);
          return;
        }
        // El backend rechazó la tarea (o respondió sin cuerpo): su mensaje a
        // la vista y el cuadro sigue abierto para no perder lo capturado.
        swal.fire({
          icon: "warning",
          text: tareaRes?.pMensaje || "No se pudo registrar la tarea. Intenta de nuevo.",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          confirmButtonText: "Aceptar",
        });
      })
      .catch(() => {
        this.sweetAlert.showSwal("error-message", null);
      });
  }

  convertirFechasHoras() {
    const momentoInicial = new Date(this.fechaInicio);
    const horaInicial = this.tareaAltaFormGroup
      .get(horaInicioCtrl)
      .value.split(Constantes.DOS_PUNTOS)[Constantes.CERO];
    momentoInicial.setHours(horaInicial);
    const minutoI = this.tareaAltaFormGroup
      .get(horaInicioCtrl)
      .value.split(Constantes.DOS_PUNTOS)[Constantes.UNO];
    momentoInicial.setMinutes(minutoI);
    const fechaInicialAjustada = new Date(
      momentoInicial.getTime() - new Date().getTimezoneOffset() * 60 * 1000
    );
    this.tarea.fecha_inicio_str = fechaInicialAjustada
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");

    const momentoFinal = new Date(this.fechaFin);
    const horaFin = this.tareaAltaFormGroup
      .get(horaFinCtrl)
      .value.split(Constantes.DOS_PUNTOS)[Constantes.CERO];
    momentoFinal.setHours(horaFin);
    const minutoF = this.tareaAltaFormGroup
      .get(horaFinCtrl)
      .value.split(Constantes.DOS_PUNTOS)[Constantes.UNO];
    momentoFinal.setMinutes(minutoF);
    const fechaFinalAjustada = new Date(
      momentoFinal.getTime() - new Date().getTimezoneOffset() * 60 * 1000
    );
    this.tarea.fecha_fin_str = fechaFinalAjustada
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");
  }

  subirEvidencia() {
    const input = <HTMLInputElement>document.getElementById("nameFile");
    if (input.files.length > Constantes.CERO) {
      for (
        let i = Constantes.CERO;
        i <= input.files.length - Constantes.UNO;
        i++
      ) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i]);
      }
    }
    (<HTMLInputElement>document.getElementById("nameFile")).value = "";
  }

  public eliminarEvidencia() {
    for (let i = Constantes.CERO; i < this.selectedOptions.length; ++i) {
      this.index = this.evidencia.findIndex(
        (item) => item.name == this.selectedOptions[i].name
      );
      this.evidencia.splice(this.index, Constantes.UNO);
    }
    (<HTMLInputElement>document.getElementById("nameFile")).value = "";
  }

  public onNgModelChange($event) {
    this.selectedOptions = $event;
    if (this.selectedOptions.length != Constantes.CERO) {
      this.btnElimina = false;
      this.btnAgrega = true;
    } else {
      this.btnElimina = true;
      this.btnAgrega = false;
    }
  }
  limpiaListaEvidencias() {
    this.evidencia = [];
  }

  consultaImagenEvidencia(value: any) {
    // El modelo TS tipa EvidenciaBean.idProyecto como number, pero en Java es
    // String y los ids de Mongo son hexadecimales: Number() lo volvía NaN (null
    // en el JSON) y la previsualización fallaba.
    this.evidenciaBean.idProyecto = this.tarea.idProyecto as unknown as number;
    this.evidenciaBean.idTarea = value.id_tarea;
    this.evidenciaBean.nombre = value.nombreArchivo;

    if (this.visorEvidencias.esImagen(this.evidenciaBean.nombre)) {
      this.muestraImagen(this.evidenciaBean);
      return;
    }

    if (this.visorEvidencias.esVideo(this.evidenciaBean.nombre)) {
      this.muestraVideo(this.evidenciaBean);
      return;
    }

    // Excel, PDF, Word, comprimidos, etc. no se pueden previsualizar:
    // se entregan directamente al usuario como descarga.
    this.descargaEvidencia(value);
  }

  muestraImagen(evidencia: EvidenciaBean) {
    this.incidenciaService.condultaImagenEvidencia(evidencia).subscribe({
      next: (res) => this.visorEvidencias.abreImagen(evidencia.nombre, res),
      error: () => this.visorEvidencias.avisoNoDisponible(),
    });
  }

  muestraVideo(evidencia: EvidenciaBean) {
    firstValueFrom(
      this.service.consultaVideoEvidencia(
        UrlConstantes.consultaVideoEvidencia,
        evidencia
      )
    )
      .then((res) => this.visorEvidencias.abreVideo(evidencia.nombre, res))
      .catch(() => this.visorEvidencias.avisoNoDisponible());
  }

  descargaEvidencia(value: any) {
    firstValueFrom(
      this.service.descargaEvidencia(
        UrlConstantes.descargaEvidencia,
        "TAREA",
        this.tarea.idProyecto,
        value.id_tarea,
        value.nombreArchivo
      )
    )
      .then((res) => this.visorEvidencias.descarga(value.nombreArchivo, res))
      .catch(() => this.visorEvidencias.avisoNoDisponible());
  }
}
